import * as actions from './actions';
import reducer from './reducer';
import * as selectors from './selectors';
import namespace from './types';

export {
    actions,
    selectors,
};

export default {
    [namespace]: reducer,
};
